export default "__VITE_ASSET__BmsfLAHi__"